import React, { useState } from 'react';
import { Button, Collapse, Card } from 'react-bootstrap';
// import parse from 'html-react-parser';
import log from "loglevel";

const AnswerExplanation = ({ explanation, correct_answer_text }) => {
  const [open, setOpen] = useState(false);
  const explanationContent = Array.isArray(explanation)
  ? explanation.map(item => item.toString()).join(' ')
  : explanation;
  explanation = "<p>"+explanation + "</p>";
  log.log("explaination ",explanation)
  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="answer-explanation"
        aria-expanded={open}
        style={{ width: '140px' }}
      >
        {open ? 'Hide Answer' : 'Answer'}
      </Button>
      <Collapse in={open}>
        <div id="answer-explanation" style={{ width: '700px', height: 'auto' }}>
          <Card style={{ marginTop: '10px' }}>
            <Card.Body>
              {correct_answer_text && <p>Correct answer is: <span>{correct_answer_text}</span></p>}
              <div dangerouslySetInnerHTML={{ __html: explanation }} />
            </Card.Body>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};

export default AnswerExplanation;
